import { createAsyncThunk } from "@reduxjs/toolkit";
import { CartItemModel, CartModel } from "../../models/cart";
import { ErrorResponse } from "../../services/fetch-util";
import { CartService } from "../../services/store/cart";

export const Cart = createAsyncThunk("cart/items/get", async () => (await CartService.getCart()).parsedBody);

export const CartAdd = createAsyncThunk<(ErrorResponse & CartModel) | undefined, CartItemModel, any>(
  "cart/items/add",
  async (cartItem: CartItemModel) => (await CartService.addToCart(cartItem)).parsedBody
);

export const CartRemove = createAsyncThunk<(ErrorResponse & CartModel) | undefined, string, any>(
  "cart/items/remove",
  async (productId: string) => (await CartService.remove(productId)).parsedBody
);
